import { getStudentUserData } from 'approot/shared/api/auth/student-user-auth';
import { getStudentData } from 'approot/student-class-to-do/student-class-to-do.utils';

export function getStudentClassToDoClassId() {
  const studentUser = getStudentUserData();
  if (studentUser) {
    return studentUser.classId;
  } else {
    const classToDoUser = getStudentData();
    return classToDoUser.teacherClassId;
  }
}
